import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { labs } from '@/store/labs';
import { tools } from '@/store/tools';
import { reports } from '@/store/reports';
import { RootState } from '@/store/types';
import { lookups } from '@/store/lookups';
import { history } from '@/store/history';
import { waitlist } from '@/store/waitlist';
import { hospitals } from '@/store/hospitals';
import { recipients } from '@/store/recipients';
import { pageState } from '@/store/currentPage';
import { globalActions } from '@/store/actions';
import { procedures } from '@/store/procedures';
import { allocations } from '@/store/allocations';
import { validations } from '@/store/validations';
import { globalMutations } from '@/store/mutations';
import { laboratories } from '@/store/laboratories';
import { coordinators } from '@/store/coordinators';
import { journeyState } from '@/store/recipientJourney';
import { deceasedDonors } from '@/store/deceasedDonors';
import { administration } from '@/store/administration';
import { organSpecificDetails } from '@/store/organSpecificDetails';
import { users } from '@/store/users';
import { userAccounts } from '@/store/userAccounts';
import { livingDonors } from '@/store/livingDonors';
import { livingAllocations } from '@/store/livingAllocations';
import { utilities } from '@/store/utilities';
import { surgicalPersons } from '@/store/surgicalPersons';
import { responsiblePhysicians } from '@/store/responsiblePhysicians';
import { dashboard } from '@/store/dashboard';
import { tasks } from '@/store/tasks';
import { features } from '@/store/features';
import { decisions } from '@/store/decisions';
import { uiEnvVersion } from '@/utils';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    pageTitle: 'Loading...',
    currentUser: null,
    systemOrganTypes: [],
    uiEnvVersion: uiEnvVersion(),
  },
  actions: globalActions,
  mutations: globalMutations,
  modules: {
    labs,
    tools,
    reports,
    lookups,
    history,
    waitlist,
    pageState,
    hospitals,
    recipients,
    procedures,
    validations,
    allocations,
    journeyState,
    laboratories,
    coordinators,
    deceasedDonors,
    administration,
    organSpecificDetails,
    users,
    userAccounts,
    livingDonors,
    livingAllocations,
    surgicalPersons,
    responsiblePhysicians,
    utilities,
    dashboard,
    tasks,
    features,
    decisions
  },
};

export default new Vuex.Store<RootState>(store);

// Required mostly to make tests easier. The app itself wont generally need to use this.
export function createNewStore() {
  return new Vuex.Store<RootState>(store);
}
